import PropTypes from 'prop-types';

const HeaderColumnShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  marginRight: PropTypes.string.isRequired,
});

export default HeaderColumnShape;
